/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
export * as operations from './operations';
export * from './data-contracts';
/** Version of the API specification */
export const specVersionHash = "7436754e6da488ca7351d44800e476ad654cc23cc765c09e51253f3fa6d79031";